/* eslint-disable no-param-reassign, consistent-return */
import {
  useState,
} from 'react';
import {
  Draggable,
} from '@hello-pangea/dnd';

import {
  ExerciseProperty,
} from '@gymcloud/core';

import {
  Icon,
  EditProperty,
  ExercisePropertyLabel,
} from 'web-components';

import {
  SVG
} from 'web-styled';

import * as S from '../styled';

type Props = {
  index: number,
  property: ExerciseProperty,
  exerciseId: number,

  onRequestSave: { (id: number, payload: any, isNew: boolean): void },
  onRequestDelete: { (propertyId: number, isNew: boolean): void },
};

const Property = ({
  index,
  property,
  exerciseId,
  onRequestSave,
  onRequestDelete,
}: Props) => {
  const [visibleForm, setVisibleForm] = useState(property.isNew);
  return visibleForm ? (
    <EditProperty
      initialValue={property}
      onSubmit={(data) => {
        onRequestSave(
          property.id,
          {
            value: data.value,
            value2: data.value2,
            property_unit_id: data.property_unit_id,
            personal_property_id: data.personal_property_id,

            position: property.position,
            workout_exercise_id: exerciseId,
          },
          property.isNew,
        );
        setVisibleForm(false);
      }}
      onDelete={() => {
        setVisibleForm(false);
        onRequestDelete(property.id, property.isNew);
      }}
    />
  ) : (
    <Draggable
      index={index}
      draggableId={String(property.id)}
    >
      {provided => (
        <S.Item
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onClick={() => setVisibleForm(true)}
        >
          <S.Label>
            <SVG.MenuBar size={12} />
            <ExercisePropertyLabel property={property} />
          </S.Label>
          <S.Remove
            icon={<SVG.X size={12} />}
            onClick={(e) => {
              e.stopPropagation();
              onRequestDelete(property.id, property.isNew);
            }}
          />
        </S.Item>
      )}
    </Draggable>
  );
};

export default Property;
